module.exports = __webpack_public_path__ + "static/repo-docs-icon-1997139e5e0904dabecd0b6d053d3055.svg";